import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import WorkerJornada from './WorkerJornada.jsx';

/** Admin/súper admin: recorre la jornada del operario sin dejar pendientes en su cuenta. */
export default function AdminJornadaPreview() {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="wjo-loading">Un momento…</div>;
    }

    if (user?.rol !== 'admin' && user?.rol !== 'superadmin') {
        return <Navigate to="/" replace />;
    }

    return <WorkerJornada previewOperario />;
}
